import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import XLSX from 'xlsx';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  Box,
  Backdrop,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { toast } from 'react-toastify';

import serverURI from 'config/URI';

import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },
}));

const form_data_compnay = [
  { 
    '회사명' : '택시회사1', 
    '권역' : '서울특별시', 
    '그룹' : '서울남부', 
    '계약상태' : '계약',
    '사업장구분' : '개인',
    '거래담당자' : '홍과장',
    '전화번호' : '02-200-0200',
    '핸드폰' : '010-010-0100',
    '메일' : 'hong@allforcab.com',
    '우편번호' : '123456',
    '주소1' : '서울시 동작구',
    '주소2' : '동작동',
  }, 
  { 
    '회사명' : '택시회사2', 
    '권역' : '서울특별시', 
    '그룹' : '서울남부', 
    '계약상태' : '계약',
    '사업장구분' : '법인',
    '거래담당자' : '김과장',
    '전화번호' : '02-200-0200',
    '핸드폰' : '010-010-0100',
    '메일' : 'kim@allforcab.com',
    '우편번호' : '123456',
    '주소1' : '서울시 송파구',
    '주소2' : '김천동',
  }, 
];

const form_data_car = [
  { 
    '차량번호' : '01가0001', 
    '택시회사명' : '택시회사1', 
    '차종' : '소나타', 
    '연식' : '2020',
    '대리점명' : '엘세븐',
  }, 
  { 
    '차량번호' : '01나0001', 
    '택시회사명' : '택시회사2', 
    '차종' : 'K5', 
    '연식' : '2018',
    '대리점명' : '엘세븐',
  }, 
];


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UploadCompanyFile = props => {

  const {
    type,
    openDialog,
    onClickCloseDialog,
    //onClickSaveDialog,

    // onClickUploadFile,
    // onClickDownloadFile,
  } = props;

  const classes = useStyles();

  const [xlsFile, setXlsFile] = useState(null);

  const [openProgress, setOpenProgress] = useState(false);

  const handleClickUploadFile = () => {

    

  }

  const handleClose = () => {
    setXlsFile(null);
    onClickCloseDialog();
  }

  const uploadCompanyFile = (file) => {
    const fileData = new FormData();
    fileData.append('xlsFile', file);
    if (type === 'taxi')
      return axios.post(`${serverURI}/api/company/taxi/upload`, fileData);
    else
      return axios.post(`${serverURI}/api/company/car/upload`, fileData);
    // return axios({
    //   method: 'post',
    //   url: `${serverURI}/api/company/taxi/upload`,
    //   data: {
    //     fileData, 
    //   }
    // });
  }

  const handleUploadCompanyFile = async (file) => {
    const res = await uploadCompanyFile(file);
    //console.log(res);
    const result_datas = type === 'taxi' ? res.data.companies : res.data.cars;
    setOpenProgress(false);

    if (result_datas.length === 0) {
      toast('업로드 사항이 존재하지 않습니다.');
      return ;
    }

    let result = true;
    let errors = [];
    result_datas.map(ret_data => {
      if (ret_data.result === 'fail') {
        result |= false;
        if (type === 'taxi')
          errors.push(ret_data.name);
        else
          errors.push(ret_data.number);
      }
    });
    if (result === true) {
      toast('업로드에 성공하였습니다.');
    }
    else {
      let errorNames = '';
      errors.map((errorName, index) => {
        errorNames += errorName;
        if (index < errors.length-1) {
          errorNames += ',';
        }
      });
      toast(errorNames+' 항목을 업로드에 실패하였습니다.');
    }
  }

  const handleDownloadCompanyFileForm = e => {

    var wscols_company = [
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:16},
      {wch:20},
      {wch:20},
      {wch:30},
      {wch:20},
      {wch:24},
      {wch:24}
    ];

    var wscols_car = [
      {wch:20},
      {wch:20},
      {wch:16},
      {wch:16},
      {wch:20},
    ];

    var wscols = type === 'taxi' ? wscols_company: wscols_car;
    var data = type === 'taxi' ? form_data_compnay: form_data_car;
    var sheet_name = type === 'taxi' ? '택시회사정보' : '차량정보';
    var file_name = type === 'taxi' ? 'company_excel' : 'car_excel';
  
    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(data); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;

    XLSX.utils.book_append_sheet(new_workbook, worksheet, sheet_name); // excelsheet를 excel파일에 넣음 
    //worksheet.getCell('A1').alignment = {vertical:'middle', horizontal:'center'};
    XLSX.writeFile(new_workbook, file_name + '.xlsx');
  }

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              업로드
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={() => {

                // const newCompany = {
                //   name: companyName,
                //   area: selectedArea,
                //   group: selectedGroup,
                //   contract: selectedContract,
                //   type: selectedCompanyType,
                //   manager: manager,
                //   tel: telephone,
                //   mobile: mobile,
                //   email: email,
                //   zipcode: zipcode,
                //   address1: address1,
                //   address2: address2,
                //   devices: 0,
                //   regAt: new Date(),
                // };

                // if (!IsNoU(editCompany))
                //   newCompany._id = editCompany._id;

                // onClickSaveDialog(newCompany);
              }}>
              닫기
            </Button> */}
          </Toolbar>
        </AppBar>

        <List>
          <Divider />
          <ListItem>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              엑셀파일
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-basic2" 
              //variant="outlined" 
              //value={videoFile.name}
              value={IsNoU(xlsFile) ? '' : xlsFile.name}
              margin="dense"
              disabled={true}/>
            <Box p={2} />
            <Button
              className={classes.registerListItemUpload}
              variant="contained"
              component="label"
            >
              파일선택
              <input
                type="file"
                accept=".xlsx"
                style={{ display: "none" }}
                onChange={e => {
                  const file = e.target.files[0];
                  if (file !== null && file !== undefined) {
                    setXlsFile(file);
                  }
                  //console.log(file);
                }}
              />
            </Button>
          </ListItem>
          <Divider />
          <ListItem>
          <div className={classes.row}>
            <Button
              color="primary"
              variant="contained"
              onClick={ () => {

                if (IsNoU(xlsFile)) {
                  //console.log('upload file none');
                  toast('업로드할 파일을 선택하세요.');
                  return ;
                }

                setOpenProgress(true);
                handleUploadCompanyFile(xlsFile);
               } }
            >
              업로드
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={ onClickCloseDialog }
            >
              취소
            </Button>

            {/* <a
              href={`${serverURI}/CMS/excel/COMPANY_EXCEL.xls`}
              download
            >
              업로드 양식 다운로드
            </a> */}

            <Button
              color="primary"
              variant="contained"
              component="label"
              onClick={ handleDownloadCompanyFileForm }
            >
              업로드 양식 다운로드
              {/* <a
                style={{ color: "white" }}
                //href={`${serverURI}/CMS/excel/COMPANY_EXCEL.xlsx`}
                herf={`${%PUBLIC_URL%}/COMPANY_EXCEL.xlsx`}
                download 
                >
                </a> */}
            </Button>
          </div>
          </ListItem>
        </List>

        <Backdrop className={classes.backdrop} open={openProgress} /* onClick={handleClose} */>
          <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>
    </div>
  );
}

export default UploadCompanyFile;
